import { OrganizationSupportChannelResolution } from "./useOrganizationSupportChannel";

import { AmplitudeEvents } from "@/common/constants/amplitude";
import { usePublishSupportChannel } from "@/components/ChatWidgetVisibilityManager/helpers/usePublishSupportChannel";

interface UsePublishOrganizationSupportChannelProps {
  resolution: OrganizationSupportChannelResolution;
  path: string;
  enabled: boolean;
}

export const usePublishOrganizationSupportChannel = (props: UsePublishOrganizationSupportChannelProps) =>
  usePublishSupportChannel({ ...props, event: AmplitudeEvents.OrganizationSupportChannelResolved });
